import type { WorkflowEditorViewProps } from './workflow-editor-view';

import { lazy, Suspense } from 'react';

import { Box, CircularProgress } from '@mui/material';

// The canvas and its styles are large. Apps that never open the editor never load them.
const Editor = lazy(() => import('./workflow-editor-view').then((module) => ({ default: module.WorkflowEditorView })));

export function WorkflowEditorView(props: WorkflowEditorViewProps) {
  return (
    <Suspense
      fallback={
        <Box sx={{ height: 1, display: 'grid', placeItems: 'center' }}>
          <CircularProgress />
        </Box>
      }
    >
      <Editor {...props} />
    </Suspense>
  );
}
